module.exports = __webpack_public_path__ + "media/images/modal-close-bold-2f1b331bc0ff12455fd3685d70ec06da.svg";